import React, {useCallback, useEffect, useState} from "react";
import {
  BoardSearchDetail,
  BoardTableContainer, ColSpan2, RowSpan,
  GraySearchButton,
} from "../../assets/GlobalStyles";
import 'react-confirm-alert/src/react-confirm-alert.css';

import {useAtom} from "jotai";
import {PaymentCondition} from "../../components/Platform/Condition";
import {paymentAllListRequest} from "../../services/payment/admin/PaymentAllListRequestAxios"
import {
  paymentColumns,
  searchPaymentParams,
  searchPaymentType,
} from "./entity/Payment";
import ReactDataGrid from "@inovua/reactdatagrid-enterprise";
import {TotalCount} from "../../components/table/styles";
import PlatformSectionHeader from "./PlatformSectionHeader";
import styled from "styled-components";
import TableScrollGuide from "./TableScrollGuide";

function PaymentManage() {
  const [isConditionOpen, setIsConditionOpen] = useState(false)
  const [totalInfo, setTotalInfo] = useState(0)
  const [searchPaymentParamsState, setSearchPaymentParamsState] = useAtom(searchPaymentParams)
  const [searchState, setSearchState] = useState(searchPaymentParamsState)

  //[d] 그리드 데이터
  const [pageSize, ] = useState(10); // 한 페이지 보여줄 데이터
  const [currentPage, ] = useState(1); // 현재 페이지

  const gridStyle = {minHeight: 510, textAlign: 'center'}

  useEffect(() => {
    handlePaymentTableData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchPaymentParamsState])
  /**
   * 검색 버튼
   */
  const handleData = () => {
    setSearchPaymentParamsState({
      ...searchState,
    })
  }
  const handleReset = resetCondition => {
    setSearchState(resetCondition)
    setSearchPaymentParamsState(resetCondition)
  }
  const handlePaymentTableData = (props={}) => { //테이블 데이터 호출 (어드민 권한은 username 없이 조회)
    const { skip = (currentPage - 1) * pageSize, limit = pageSize } = props;

    const requestData = {
      pageSize: limit,
      currentPage: skip / limit + 1,
      searchStartDate: searchPaymentParamsState.startAt,
      searchEndDate: searchPaymentParamsState.endAt,
      // pointHistoryTypes: null,
      // paymentStatusTypes: null,
      //[d] 결제 신청만 있어서 null 이 아니면 볼 수 없어요~!
      paymentStatusType: searchPaymentParamsState.statusList,
      keywordType: searchPaymentParamsState.searchType,
      keyword: searchPaymentParamsState.search
    };
    return paymentAllListRequest ( requestData )
      .then(response => {
        // 성공적인 응답 처리
        if (response !== null) {
          const { totalCount, rows: data } = response;
          setTotalInfo(totalCount);
          return Promise.resolve({ data, count: parseInt(totalCount) });
        } else {
          return Promise.resolve({ data: [], count: 0 });
        }
      })
      .catch(error => {
        // 실패한 응답 처리
        console.error("실패 응답 처리",error);
      });
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const dataCallback = useCallback( handlePaymentTableData , [totalInfo, searchPaymentParamsState])

  return (
    <PaymentManageCards>
      <PaymentCard $condition>
        <PlatformSectionHeader title="조회 조건" description="기간, 결제 상태와 검색어를 기준으로 결제 내역을 조회합니다." collapsible open={isConditionOpen} onToggle={() => setIsConditionOpen(prev => !prev)}/>
        {isConditionOpen && <PaymentConditionBody><PaymentCondition searchType={searchPaymentType} searchCondition={searchState} setSearchCondition={setSearchState} handleTableData={handleData} handleReset={handleReset}/></PaymentConditionBody>}
      </PaymentCard>
      <PaymentCard>
        <PlatformSectionHeader title="결제 목록" description="광고주의 결제 요청과 처리 상태를 확인합니다." count={totalInfo} unit="건"/>
        <PaymentListBody>
          <RowSpan>
              {/*<SaveExcelButton>엑셀 저장</SaveExcelButton>*/}
          </RowSpan>
          {/*<TableScrollGuide/>*/}
          <ReactDataGrid
            licenseKey={process.env.REACT_APP_DATA_GRID_LICENSE_KEY}
            handle={null}
            columns={paymentColumns}
            dataSource={dataCallback}
            headerHeight={48}
            showZebraRows={true}
            showCellBorders={'horizontal'}
            enableColumnAutosize={true}
            showColumnMenuLockOptions={false}
            showColumnMenuGroupOptions={false}
            emptyText={'결제 내역이 없습니다.'}
            pagination={false}
            sortable={false}
            style={gridStyle}
            activeCell={null}
          />
        </PaymentListBody>
      </PaymentCard>
    </PaymentManageCards>
  )
}

export default PaymentManage

const PaymentManageCards = styled.div`
  display:flex;width:100%;flex-direction:column;gap:16px;
`;

const PaymentCard = styled.section`
  position:relative;z-index:${({$condition}) => $condition ? 10 : 1};
  overflow:${({$condition}) => $condition ? "visible" : "hidden"};
  border:1px solid #e5e8eb;border-radius:10px;background:#fff;
  box-shadow:0 5px 18px rgba(31,41,55,.045);
`;

const PaymentConditionBody = styled.div`
  min-height:190px;box-sizing:border-box;padding:22px 24px 28px;background:#fff;
  > div, > div > div {box-sizing:border-box;}

  ${BoardSearchDetail} {
    margin:0 !important;padding:0 !important;border:0 !important;background:transparent !important;
  }

  ${GraySearchButton} {
    min-width:82px;height:40px;padding:0 17px;border:1px solid #f5811f;
    border-radius:6px;background:#fff4e8;color:#f5811f;font-size:var(--font-size-13);font-weight:700;
  }
  ${GraySearchButton}:hover {background:#ffe8d2;color:#f5811f;}
`;

const PaymentListBody = styled(BoardTableContainer)`
  padding:18px 20px 20px;border:0 !important;background:#fff;
  .InovuaReactDataGrid {border:1px solid #e5e8eb !important;border-radius:8px;box-shadow:none !important;}
`;



